import { render, staticRenderFns } from "./ingredients.vue?vue&type=template&id=100bc43c&scoped=true&"
import script from "./ingredients.vue?vue&type=script&lang=js&"
export * from "./ingredients.vue?vue&type=script&lang=js&"
import style0 from "./ingredients.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ingredients.vue?vue&type=style&index=1&id=100bc43c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100bc43c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/kroppensabc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('100bc43c')) {
      api.createRecord('100bc43c', component.options)
    } else {
      api.reload('100bc43c', component.options)
    }
    module.hot.accept("./ingredients.vue?vue&type=template&id=100bc43c&scoped=true&", function () {
      api.rerender('100bc43c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ingredients.vue"
export default component.exports